import { render } from "./Thankyoupage.vue?vue&type=template&id=404280ca&scoped=true&ts=true"
import script from "./Thankyoupage.vue?vue&type=script&lang=ts"
export * from "./Thankyoupage.vue?vue&type=script&lang=ts"

import "./Thankyoupage.vue?vue&type=style&index=0&id=404280ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404280ca"]])

export default __exports__